// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.tags {
    display: flex;
    flex-wrap: wrap;
    gap: 3px;
}

.tags .tag {
    position: relative;
    height: 24px;

    padding-left: 8px;
    padding-right: 8px;
    padding-top: 1px;
    padding-bottom: 2px;
    margin-bottom: 3px;
    margin-right: 2px;

    border: var(--black-20) solid 1px;
    border-radius: 14px;

    color: var(--black-65);
    background-color: var(--black-15);

    user-select: none; 

    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
}

.tags .tag.removable {
    padding-right: 0px;
}

.tags .tag .name {
    font-size: 13px;
    padding-top: 1px;

    white-space: nowrap;
    overflow: hidden;
}

.tags .tag.add {
    text-align: center;
    padding-top: 2px;
    padding-left: 4px;
    padding-right: 4px;
    border:none;
    font-size: 13px;
}

.tags .tag.add.empty {
    padding-right: 10px;
}

.tags .tag.add .symbols {
    font-size: 20px;
    width: 20px;

    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
}

.tags .tag.add:hover {
    color: var(--black-05);
    background-color: var(--black-45);
}

.tags .tag.add > .title {
    /* Figma "btn new tag" label (node 16:17428) */
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.025em;
    text-transform: uppercase;

    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
}

.tags .tag.selected {
    color: var(--black-05);
    background-color: var(--black-80);
}

.tags .tag:not(.new):not(.add) .remove {
    border-radius: 16px;
    text-align: center;
    font-size: 16px;
    margin-left: 3px;
    padding-left: 3px;
    padding-right: 3px;

    user-select: none;
    cursor: pointer;
}

/* Hover uses one shared medium-light treatment across browser and assigned
   tags. Selected filters keep their dedicated light selected surface. */
.tags .tag:not(.new):not(.add):not(.selected):hover {
    color: var(--black-03);
    background-color: var(--black-45);
    background-image: none;
}

.tag-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 999;
    user-select: none;
}

.tag-modal .titlebar {
    position: relative;
    width: 100%;
    height: var(--ui-modal-header-height);
    padding-left: 10px;

    border-top-right-radius: var(--ui-modal-radius);
    border-top-left-radius: var(--ui-modal-radius);

    font-size: 15px;
    font-weight: 700;
    text-transform: uppercase;

    display: flex;
    justify-content: space-between;
    text-align: center;
    align-items: center;

    background-color: var(--ui-modal-header-bg);
}

.tag-modal .titlebar .title {
    width: 85%;


    letter-spacing: 0px;
    text-overflow: clip;
    overflow: hidden;
    white-space: nowrap;
    mask: linear-gradient(to right, black 70%, transparent 100%);
}

.tag-modal .titlebar .dismiss {
    position: absolute;
    right: 10px;
    top: 5px;
    font-size: 24px;
    font-weight: 300;
    line-height: 1;
    color: var(--black-80);
    font-family: 'Material Symbols Outlined Thin', 'Material Symbols Outlined';
}

.tag-modal .titlebar .dismiss:hover {
    filter: brightness(1.2);
}

.tag-modal .body {
    margin-left: 16px;
    margin-right: 16px;

    display:flex;
    flex-direction: column;
    justify-content: space-around;
    gap: 10px;
}

.tag-modal > .tag-browser {
    font-size: 14px;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 280px;
    transform: translate(-50%, -50%);

    color: var(--black-80);
    background-color: var(--ui-modal-bg);

    box-shadow: var(--ui-modal-shadow);
    border-radius: var(--ui-modal-radius);
}

.tag-browser .browser-tags {
    height: 220px;
    overflow-y: auto;
    padding-right: 5px;
}

.tag-browser .none {
    color: var(--black-45);
    font-style: italic;
}

.tag-browser .div {
    height: 1px;
    background-color: var(--black-20);
}

.tag-browser .tag-editable {
    height: 27px;
    display: flex;
    justify-content: space-between;
    text-align: left;
    align-items: center;
}

.tag-browser .tag-editable .tag-name {
    color: var(--black-65);
    width: 100%;

    padding-top: 2px;
    padding-left: 5px;
    padding-right: 5px;

    white-space: nowrap;
    overflow: hidden;
    mask: linear-gradient(to right, black 75%, transparent 100%);
}

.tag-browser .tag-editable .tag-name.edit {
    mask: none;
}

.tag-browser .tag-editable .tag-icons .assigned {
    color: var(--green-1);
}

.tag-browser .tag-editable .tag-icons .add {
    color: var(--black-45);
}

.tag-browser .tag-editable .tag-icons > .icon {
    font-size: 16px;
    border-radius: 12px;
    padding: 2px;
    padding-left: 4px;
    padding-right: 4px;
}

.tag-browser .tag-editable .tag-icons > .icon:hover {
    background-color: var(--black-15);
}

.tag-browser .tag-editable .tag-icons {
    display: flex;
    justify-content: space-between;
    text-align: center;
    align-items: center;
    gap: 10px;

    user-select: none;
    cursor: pointer;
}

.tag-browser .tag-editable .tag-icons .remove {
    color: var(--black-45);
}

.tag-browser .editable .tag-name.edit {
    color: var(--black-90);
    border: var(--black-90) solid 1px;
    border-radius: 4px;
    text-overflow: clip;
    background-color: var(--black-20);
}

.tag-browser .editable .tag-name.edit.warn {
    color: red;
}

.tag-browser .search {
    height: 32px;
    margin-top: 12px;
}

.tag-browser .create-tag {
    min-height: 30px;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 6px;
    color: var(--black-65);
    cursor: pointer;
}

.tag-browser .create-tag:hover {
    background-color: var(--black-15);
}

.tag-browser .create-tag .icon {
    font-size: 18px;
}

.tag-browser .search .icon {
    position: absolute;
    left: 8px;
    font-size: 22px;
    color: var(--black-45);
    user-select: none; 
}

.tag-browser .searchbox {
    font-size: 14px;
  
    width: 100%;
    height: 32px;
    /** if missing, caret appears in upper left of searchbox when empty (and focused) */
    padding: 0;
    padding-left: 33px;

    color: var(--black-65);
    background-color: var(--black-10);

    border: solid var(--black-15) 1px;
    border-radius: 4px;

    /** prevents default outlining of active input text box */
    outline: none;

    white-space: nowrap;
    text-overflow: clip;
    text-align: left;
    overflow: hidden;
}

.tag-browser .searchbox {
    letter-spacing: 0;
}

.tag-browser .searchbox.empty {
    color: var(--black-45);
    user-select: none; 
}

.tag-browser .searchbox.edit {
    font-style: normal;
    text-overflow: clip;
    overflow: hidden;
    color: var(--black-80);
    background-color: var(--black-20);
}

.tag-browser .body > .assigned.tags {
    margin-top: 12px;
    min-height: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/tag.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,YAAY;;IAEZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;;IAEjB,iCAAiC;IACjC,mBAAmB;;IAEnB,sBAAsB;IACtB,iCAAiC;;IAEjC,iBAAiB;;IAEjB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;;IAEhB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;;IAEX,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,8CAA8C;IAC9C,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;;IAEzB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;;IAElB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;wEACwE;AACxE;IACI,sBAAsB;IACtB,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,qCAAqC;IACrC,kBAAkB;;IAElB,+CAA+C;IAC/C,8CAA8C;;IAE9C,eAAe;IACf,gBAAgB;IAChB,yBAAyB;;IAEzB,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;;IAEnB,2CAA2C;AAC/C;;AAEA;IACI,UAAU;;;IAGV,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,4DAA4D;AAChE;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,0EAA0E;AAC9E;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;;IAElB,YAAY;IACZ,sBAAsB;IACtB,6BAA6B;IAC7B,SAAS;AACb;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,gCAAgC;;IAEhC,sBAAsB;IACtB,oCAAoC;;IAEpC,kCAAkC;IAClC,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iCAAiC;AACrC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,WAAW;;IAEX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;;IAElB,mBAAmB;IACnB,gBAAgB;IAChB,4DAA4D;AAChE;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;;IAET,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,iCAAiC;IACjC,kBAAkB;IAClB,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,eAAe;IACf,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,eAAe;;IAEf,WAAW;IACX,YAAY;IACZ,mFAAmF;IACnF,UAAU;IACV,kBAAkB;;IAElB,sBAAsB;IACtB,iCAAiC;;IAEjC,iCAAiC;IACjC,kBAAkB;;IAElB,yDAAyD;IACzD,aAAa;;IAEb,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":["\n.tags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 3px;\n}\n\n.tags .tag {\n    position: relative;\n    height: 24px;\n\n    padding-left: 8px;\n    padding-right: 8px;\n    padding-top: 1px;\n    padding-bottom: 2px;\n    margin-bottom: 3px;\n    margin-right: 2px;\n\n    border: var(--black-20) solid 1px;\n    border-radius: 14px;\n\n    color: var(--black-65);\n    background-color: var(--black-15);\n\n    user-select: none; \n\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    align-items: center;\n}\n\n.tags .tag.removable {\n    padding-right: 0px;\n}\n\n.tags .tag .name {\n    font-size: 13px;\n    padding-top: 1px;\n\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n.tags .tag.add {\n    text-align: center;\n    padding-top: 2px;\n    padding-left: 4px;\n    padding-right: 4px;\n    border:none;\n    font-size: 13px;\n}\n\n.tags .tag.add.empty {\n    padding-right: 10px;\n}\n\n.tags .tag.add .symbols {\n    font-size: 20px;\n    width: 20px;\n\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    align-items: center;\n}\n\n.tags .tag.add:hover {\n    color: var(--black-05);\n    background-color: var(--black-45);\n}\n\n.tags .tag.add > .title {\n    /* Figma \"btn new tag\" label (node 16:17428) */\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.025em;\n    text-transform: uppercase;\n\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    align-items: center;\n}\n\n.tags .tag.selected {\n    color: var(--black-05);\n    background-color: var(--black-80);\n}\n\n.tags .tag:not(.new):not(.add) .remove {\n    border-radius: 16px;\n    text-align: center;\n    font-size: 16px;\n    margin-left: 3px;\n    padding-left: 3px;\n    padding-right: 3px;\n\n    user-select: none;\n    cursor: pointer;\n}\n\n/* Hover uses one shared medium-light treatment across browser and assigned\n   tags. Selected filters keep their dedicated light selected surface. */\n.tags .tag:not(.new):not(.add):not(.selected):hover {\n    color: var(--black-03);\n    background-color: var(--black-45);\n    background-image: none;\n}\n\n.tag-modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.6);\n    z-index: 999;\n    user-select: none;\n}\n\n.tag-modal .titlebar {\n    position: relative;\n    width: 100%;\n    height: var(--ui-modal-header-height);\n    padding-left: 10px;\n\n    border-top-right-radius: var(--ui-modal-radius);\n    border-top-left-radius: var(--ui-modal-radius);\n\n    font-size: 15px;\n    font-weight: 700;\n    text-transform: uppercase;\n\n    display: flex;\n    justify-content: space-between;\n    text-align: center;\n    align-items: center;\n\n    background-color: var(--ui-modal-header-bg);\n}\n\n.tag-modal .titlebar .title {\n    width: 85%;\n\n\n    letter-spacing: 0px;\n    text-overflow: clip;\n    overflow: hidden;\n    white-space: nowrap;\n    mask: linear-gradient(to right, black 70%, transparent 100%);\n}\n\n.tag-modal .titlebar .dismiss {\n    position: absolute;\n    right: 10px;\n    top: 5px;\n    font-size: 24px;\n    font-weight: 300;\n    line-height: 1;\n    color: var(--black-80);\n    font-family: 'Material Symbols Outlined Thin', 'Material Symbols Outlined';\n}\n\n.tag-modal .titlebar .dismiss:hover {\n    filter: brightness(1.2);\n}\n\n.tag-modal .body {\n    margin-left: 16px;\n    margin-right: 16px;\n\n    display:flex;\n    flex-direction: column;\n    justify-content: space-around;\n    gap: 10px;\n}\n\n.tag-modal > .tag-browser {\n    font-size: 14px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 280px;\n    transform: translate(-50%, -50%);\n\n    color: var(--black-80);\n    background-color: var(--ui-modal-bg);\n\n    box-shadow: var(--ui-modal-shadow);\n    border-radius: var(--ui-modal-radius);\n}\n\n.tag-browser .browser-tags {\n    height: 220px;\n    overflow-y: auto;\n    padding-right: 5px;\n}\n\n.tag-browser .none {\n    color: var(--black-45);\n    font-style: italic;\n}\n\n.tag-browser .div {\n    height: 1px;\n    background-color: var(--black-20);\n}\n\n.tag-browser .tag-editable {\n    height: 27px;\n    display: flex;\n    justify-content: space-between;\n    text-align: left;\n    align-items: center;\n}\n\n.tag-browser .tag-editable .tag-name {\n    color: var(--black-65);\n    width: 100%;\n\n    padding-top: 2px;\n    padding-left: 5px;\n    padding-right: 5px;\n\n    white-space: nowrap;\n    overflow: hidden;\n    mask: linear-gradient(to right, black 75%, transparent 100%);\n}\n\n.tag-browser .tag-editable .tag-name.edit {\n    mask: none;\n}\n\n.tag-browser .tag-editable .tag-icons .assigned {\n    color: var(--green-1);\n}\n\n.tag-browser .tag-editable .tag-icons .add {\n    color: var(--black-45);\n}\n\n.tag-browser .tag-editable .tag-icons > .icon {\n    font-size: 16px;\n    border-radius: 12px;\n    padding: 2px;\n    padding-left: 4px;\n    padding-right: 4px;\n}\n\n.tag-browser .tag-editable .tag-icons > .icon:hover {\n    background-color: var(--black-15);\n}\n\n.tag-browser .tag-editable .tag-icons {\n    display: flex;\n    justify-content: space-between;\n    text-align: center;\n    align-items: center;\n    gap: 10px;\n\n    user-select: none;\n    cursor: pointer;\n}\n\n.tag-browser .tag-editable .tag-icons .remove {\n    color: var(--black-45);\n}\n\n.tag-browser .editable .tag-name.edit {\n    color: var(--black-90);\n    border: var(--black-90) solid 1px;\n    border-radius: 4px;\n    text-overflow: clip;\n    background-color: var(--black-20);\n}\n\n.tag-browser .editable .tag-name.edit.warn {\n    color: red;\n}\n\n.tag-browser .search {\n    height: 32px;\n    margin-top: 12px;\n}\n\n.tag-browser .create-tag {\n    min-height: 30px;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 6px;\n    color: var(--black-65);\n    cursor: pointer;\n}\n\n.tag-browser .create-tag:hover {\n    background-color: var(--black-15);\n}\n\n.tag-browser .create-tag .icon {\n    font-size: 18px;\n}\n\n.tag-browser .search .icon {\n    position: absolute;\n    left: 8px;\n    font-size: 22px;\n    color: var(--black-45);\n    user-select: none; \n}\n\n.tag-browser .searchbox {\n    font-size: 14px;\n  \n    width: 100%;\n    height: 32px;\n    /** if missing, caret appears in upper left of searchbox when empty (and focused) */\n    padding: 0;\n    padding-left: 33px;\n\n    color: var(--black-65);\n    background-color: var(--black-10);\n\n    border: solid var(--black-15) 1px;\n    border-radius: 4px;\n\n    /** prevents default outlining of active input text box */\n    outline: none;\n\n    white-space: nowrap;\n    text-overflow: clip;\n    text-align: left;\n    overflow: hidden;\n}\n\n.tag-browser .searchbox {\n    letter-spacing: 0;\n}\n\n.tag-browser .searchbox.empty {\n    color: var(--black-45);\n    user-select: none; \n}\n\n.tag-browser .searchbox.edit {\n    font-style: normal;\n    text-overflow: clip;\n    overflow: hidden;\n    color: var(--black-80);\n    background-color: var(--black-20);\n}\n\n.tag-browser .body > .assigned.tags {\n    margin-top: 12px;\n    min-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
